// extracted by mini-css-extract-plugin
module.exports = {"button":"src-components-SimpleButton-styles__button--5IXmf"};